import createCache from '@emotion/cache';
export var KEY = "e";
var emotionCache = createCache({
  key: KEY
});
export default emotionCache;